import { API_URL } from '../../../app-config/constants';
import { CompanyListDto } from '../../../types/CompanyDtos';
import { get } from '../request';

type CompanySort = 'size' | 'creation' | 'expiry' | 'name';

type CompanyQuery = {
    limit: number;
    offset: number;
    sort?: CompanySort;
    query?: string;
};

query.operation = 'READ';
export function query({ offset, limit, sort = 'size', ...rest }: CompanyQuery) {
    return get<CompanyListDto[]>(`${API_URL}/all-companies`, {
        getData: { offset: offset.toString(), limit: limit.toString(), sort, ...rest },
    });
}

// Uses the same api as Company.ts, but using it here will allow ladda to return a cached version
// from the query-call. Use if you only need the smaller shape and are likely coming from the company list
getCompany.operation = 'READ';
getCompany.byId = true;
export function getCompany(id: string) {
    return get<CompanyListDto>(`${API_URL}/companies/${id}`);
}
